var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.667,95.999c-3.313,0-6-2.687-6-6c0-5.52-2.149-10.709-6.053-14.613C20.71,71.482,15.521,69.333,10,69.333   c-3.313,0-6-2.687-6-6s2.687-6,6-6c8.726,0,16.929,3.398,23.099,9.568s9.568,14.373,9.568,23.098   C42.667,93.312,39.98,95.999,36.667,95.999z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.333,95.999c-3.313,0-6-2.687-6-6c0-12.643-4.923-24.528-13.862-33.469C34.53,47.591,22.644,42.667,10,42.667   c-3.313,0-6-2.687-6-6s2.687-6,6-6c15.849,0,30.749,6.172,41.955,17.379C63.161,59.252,69.333,74.15,69.333,89.999   C69.333,93.312,66.646,95.999,63.333,95.999z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90,95.999c-3.313,0-6-2.687-6-6c0-19.766-7.697-38.348-21.674-52.325C48.349,23.697,29.766,16,10,16c-3.313,0-6-2.687-6-6   s2.687-6,6-6c22.972,0,44.567,8.945,60.811,25.189C87.055,45.433,96,67.028,96,89.999C96,93.312,93.313,95.999,90,95.999z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,96c-1.58,0-3.13-0.641-4.24-1.76C4.64,93.13,4,91.58,4,90s0.64-3.13,1.76-4.24C6.87,84.64,8.42,84,10,84   s3.13,0.64,4.24,1.76C15.359,86.87,16,88.42,16,90s-0.641,3.12-1.76,4.24C13.13,95.359,11.58,96,10,96z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisible);
export default __webpack_public_path__ + "static/media/invisible.6392bf466513a928648e7f3f1fe73fc8.svg";
export { ForwardRef as ReactComponent };